/**
 * Gruns LP buy box — scroll helpers, gallery, and SKIO price sync.
 * Legacy reference: MFRBWVariantPackForm (read-only).
 */

(function () {
  if (window.__ctrLpBuyboxInitialized) return;
  window.__ctrLpBuyboxInitialized = true;

  const BUYBOX_ID = 'ctr-lp-product-buybox';
  const SCROLL_SELECTOR = '[data-ctr-lp-scroll-to-buybox]';
  const ATC_SELECTOR = '[data-ctr-lp-trigger-atc]';

  function getHeaderOffset() {
    const headerMini = document.querySelector('.header .header__mini');
    if (headerMini?.offsetHeight) return headerMini.offsetHeight;
    return headerMini?.classList.contains('is-collapsed') ? 44 : 56;
  }

  function getBuyboxElement() {
    return (
      document.getElementById(BUYBOX_ID) ||
      document.querySelector('.ctr-lp-product-buybox')
    );
  }

  function syncGalleryFooterA11y() {
    const buybox = getBuyboxElement();
    if (buybox?.dataset.layoutVariant !== 'primary_essentials') return;

    const desktopFooter = buybox.querySelector('[data-ctr-lp-gallery-footer-desktop]');
    const mobileFooter = buybox.querySelector('[data-ctr-lp-gallery-footer-mobile]');
    const isDesktop = window.matchMedia('(min-width: 64em)').matches;

    if (desktopFooter) {
      desktopFooter.setAttribute('aria-hidden', isDesktop ? 'false' : 'true');
    }
    if (mobileFooter) {
      mobileFooter.setAttribute('aria-hidden', isDesktop ? 'true' : 'false');
    }
  }

  function scrollToBuybox() {
    const target = getBuyboxElement();
    if (!target) return false;
    const top =
      target.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
    window.scrollTo({ top, behavior: 'smooth' });
    return true;
  }

  let atcTriggerLock = false;

  function shouldRedirectToCheckout(buybox) {
    buybox = buybox || getBuyboxElement();
    return buybox?.dataset?.ctrLpRedirectCheckout === "true";
  }

  function buildAddToCartOptions(buybox) {
    const options = {
      niceTitle: buybox?.dataset?.niceTitle || "",
    };

    if (shouldRedirectToCheckout(buybox)) {
      options.redirectToCheckout = true;
    }

    return options;
  }

  function getCheckoutUrl() {
    return window.Shopify?.routes?.root
      ? `${window.Shopify.routes.root}checkout`
      : "/checkout";
  }

  function getSkioForm(buybox) {
    buybox = buybox || getBuyboxElement();
    return buybox?.querySelector(".variant-pack-form");
  }

  function getSkioFormData(buybox) {
    const form = getSkioForm(buybox);
    if (!form) return null;

    try {
      return window.Alpine?.$data?.(form) || null;
    } catch (_e) {
      return null;
    }
  }

  async function performBuyboxAddToCart(formData, buybox) {
    const options = buildAddToCartOptions(buybox);
    const redirect = Boolean(options.redirectToCheckout);
    const offCanvasStore = redirect ? Alpine.store("offCanvasCart") : null;
    const originalOpenOffcanvas = offCanvasStore?.openOffcanvas?.bind(offCanvasStore);

    if (redirect && offCanvasStore && originalOpenOffcanvas) {
      offCanvasStore.openOffcanvas = () => {};
    }

    try {
      await formData.addToCart(options);

      if (redirect) {
        window.location.href = getCheckoutUrl();
      }
    } finally {
      if (redirect && offCanvasStore && originalOpenOffcanvas) {
        offCanvasStore.openOffcanvas = originalOpenOffcanvas;
      }
    }
  }

  async function triggerBuyboxAtc() {
    if (atcTriggerLock) return true;

    const buybox = getBuyboxElement();
    const formData = getSkioFormData(buybox);

    if (formData?.isFull?.() && typeof formData.addToCart === "function") {
      atcTriggerLock = true;
      try {
        await performBuyboxAddToCart(formData, buybox);
        return true;
      } catch (_e) {
        /* fall through to hidden button click */
      } finally {
        window.setTimeout(() => {
          atcTriggerLock = false;
        }, 1500);
      }
    }

    const wrapper = buybox?.querySelector(".variant-pack-form__submit-wrapper");
    const btn = wrapper?.querySelector("button");
    if (btn && !btn.disabled) {
      atcTriggerLock = true;
      btn.click();
      window.setTimeout(() => {
        atcTriggerLock = false;
      }, 1500);
      return true;
    }

    return scrollToBuybox();
  }

  function onDocumentClick(event) {
    const scrollTrigger = event.target.closest(SCROLL_SELECTOR);
    if (scrollTrigger) {
      event.preventDefault();
      scrollToBuybox();
      return;
    }
    const atcTrigger = event.target.closest(ATC_SELECTOR);
    if (atcTrigger) {
      event.preventDefault();
      triggerBuyboxAtc();
    }
  }

  function onHeaderVariantPackClick(event) {
    if (!document.querySelector('[data-ctr-lp-hero]')) return;

    const headerBtn = event.target.closest('.header__variant-pack-atc button');
    if (!headerBtn) return;

    const buybox = getBuyboxElement();
    if (!buybox) return;

    const ctrForm = document.querySelector(
      '.ctr-lp-product-buybox .variant-pack-form__submit-wrapper button'
    );
    if (ctrForm && !headerBtn.disabled) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    scrollToBuybox();
  }

  function formatMoneyFromCents(cents) {
    // Keep cents only when the amount isn't a whole dollar, so $47.40 shows in
    // full while clean prices like $54 / $79 stay decimal-free.
    const hasFraction = Math.round(cents) % 100 !== 0;
    if (typeof Shopify === 'undefined' || !Shopify.formatMoney) {
      return `$${(cents / 100).toFixed(hasFraction ? 2 : 0)}`;
    }
    const baseFormat = Shopify.money_format || '${{amount}}';
    const format = hasFraction
      ? baseFormat
      : baseFormat.replace('amount', 'amount_no_decimals');
    return Shopify.formatMoney(cents, format);
  }

  const PER_DAY_BASIS_DEFAULT = 30;

  function getPerDayBasis() {
    const buybox = getBuyboxElement();
    const pricesEl = buybox?.querySelector('[x-ref="productTopPrices"]');
    try {
      const data = pricesEl && window.Alpine?.$data?.(pricesEl);
      if (data?.piecePerPack > 0) return data.piecePerPack;
    } catch (_e) {
      /* Alpine may not be ready */
    }
    return PER_DAY_BASIS_DEFAULT;
  }

  function formatPerDayFromCents(cents, dayBasis) {
    const basis = dayBasis || getPerDayBasis();
    if (!cents || !basis) return '';
    const perDay = cents / 100 / basis;
    return `$${perDay.toFixed(2)}`;
  }

  function isValidDisplayPrice(price) {
    if (!price || typeof price !== 'string') return false;
    const normalized = price.replace(/\s+/g, ' ').trim();
    return /^\$[\d,]+(?:\.\d{2})?/.test(normalized);
  }

  function readFrequencyPricing(input) {
    if (!input) return null;

    let data = null;
    try {
      data = window.Alpine?.$data?.(input);
    } catch (_e) {
      /* Alpine may not be ready */
    }

    if (data?.rawPrice != null) {
      const compareCents = data.rawComparePrice || data.rawOriginalPrice;
      const discountPercent =
        compareCents > data.rawPrice
          ? Math.round((1 - data.rawPrice / compareCents) * 100)
          : data.subscriptionDiscountPercent > 0
            ? data.subscriptionDiscountPercent
            : 0;

      return {
        price: formatMoneyFromCents(data.rawPrice),
        compare: compareCents ? formatMoneyFromCents(compareCents) : null,
        rawPrice: data.rawPrice,
        rawComparePrice: compareCents,
        servingsCount: data.servingsCount || 0,
        deliveryDays: data.deliveryDays || data.servingsCount || 0,
        discountPercent,
        isSubscription: Boolean(data.sellingPlanID),
        frequencyLabel: data.frequencyLabel || input.value || '',
      };
    }

    const parsed = readFrequencyPrice(input);
    return parsed?.price
      ? {
          price: parsed.price,
          compare: parsed.compare,
          rawPrice: null,
          rawComparePrice: null,
          servingsCount: 0,
          deliveryDays: 0,
          discountPercent: 0,
          isSubscription: false,
          frequencyLabel: input.value || '',
        }
      : null;
  }

  function applyPricingTemplate(template, values) {
    if (!template) return '';
    return template
      .replace(/\[discount\]/g, values.discount)
      .replace(/\[discount_percent\]/g, values.discount)
      .replace(/\[per_day\]/g, values.perDay)
      .replace(/\[days\]/g, values.days);
  }

  function buildTemplateValues(pricing) {
    if (!pricing) {
      return { discount: '', perDay: '', days: '' };
    }

    const perDay = pricing.rawPrice ? formatPerDayFromCents(pricing.rawPrice) : '';
    const discount = pricing.isSubscription ? String(pricing.discountPercent) : '';
    const days = pricing.deliveryDays ? String(pricing.deliveryDays) : '';

    return { discount, perDay, days };
  }

  function buildPricingDisplayValues(pricing, templates) {
    if (!pricing) {
      return {
        promoBadge: '',
        supplyBadge: '',
        priceNote: '',
        subscriptionFooter: '',
      };
    }

    const templateValues = buildTemplateValues(pricing);
    const hasDays = Boolean(pricing.deliveryDays);

    return {
      promoBadge: pricing.isSubscription
        ? applyPricingTemplate(templates.promoBadge, templateValues)
        : '',
      supplyBadge: hasDays
        ? applyPricingTemplate(templates.supplyBadge, templateValues)
        : null,
      priceNote: pricing.isSubscription
        ? applyPricingTemplate(templates.priceNote, templateValues)
        : '',
      subscriptionFooter: pricing.isSubscription
        ? applyPricingTemplate(templates.subscriptionFooter, templateValues)
        : '',
    };
  }

  function syncGalleryPricing(pricing) {
    const buybox = getBuyboxElement();
    const pricesEl = buybox?.querySelector('[x-ref="productTopPrices"]');
    if (!pricesEl || !pricing) return;

    try {
      const pricesData = window.Alpine?.$data?.(pricesEl);
      if (!pricesData) return;

      if (pricing.rawPrice != null) {
        pricesData.totalPrice = pricing.isSubscription
          ? pricing.rawPrice
          : pricing.rawComparePrice || pricing.rawPrice;
      }
      pricesData.allBlack = !pricing.isSubscription;
    } catch (_e) {
      /* Alpine may not be ready */
    }
  }

  function syncPurchaseCards(pricing) {
    const cards = document.querySelectorAll('[data-ctr-lp-sync-pricing]');
    const values = buildTemplateValues(pricing);
    const hasLivePricing = Boolean(pricing?.isSubscription);

    cards.forEach((card) => {
      // Sections with "Always use fallback pricing" opt out of live sync.
      if (card.closest('[data-ctr-lp-pricing-lock]')) return;
      const priceEl = card.querySelector('[data-ctr-lp-sync-price]');
      const compareEl = card.querySelector('[data-ctr-lp-sync-compare]');
      const badgeEl = card.querySelector('[data-ctr-lp-sync-badge]');
      const priceNoteEl = card.querySelector('[data-ctr-lp-sync-price-note]');
      const ctaEl = card.querySelector('[data-ctr-lp-sync-cta]');
      const subNoteEl = card.querySelector('[data-ctr-lp-sync-subscription-note]');

      if (priceEl && pricing?.price) {
        priceEl.textContent = pricing.price;
      }

      if (compareEl) {
        const showCompare = Boolean(pricing?.compare && pricing?.isSubscription);
        if (hasLivePricing) {
          compareEl.textContent = showCompare ? pricing.compare : compareEl.textContent;
          compareEl.hidden = !showCompare;
        }
      }

      if (badgeEl && hasLivePricing) {
        const template = card.dataset.badgeTemplate || badgeEl.dataset.template || '';
        const badgeText = applyPricingTemplate(template, values);
        if (badgeText) {
          badgeEl.textContent = badgeText;
          badgeEl.hidden = false;
        }
      }

      if (priceNoteEl && hasLivePricing) {
        const template = card.dataset.priceNoteTemplate || priceNoteEl.dataset.template || '';
        const noteHtml = applyPricingTemplate(template, values);
        if (noteHtml) {
          priceNoteEl.innerHTML = noteHtml;
          priceNoteEl.hidden = false;
        }
      }

      if (ctaEl && hasLivePricing) {
        const template = card.dataset.ctaTemplate || ctaEl.dataset.template || '';
        const ctaText = applyPricingTemplate(template, values);
        if (ctaText) {
          ctaEl.textContent = ctaText;
        }
      }

      if (subNoteEl && hasLivePricing) {
        const template =
          card.dataset.subscriptionNoteTemplate || subNoteEl.dataset.template || '';
        const noteHtml = applyPricingTemplate(template, values);
        if (noteHtml) {
          subNoteEl.innerHTML = noteHtml;
          subNoteEl.hidden = false;
        }
      }
    });

    syncStandalonePricingElements(pricing, values, hasLivePricing);
  }

  function syncStandalonePricingElements(pricing, values, hasLivePricing) {
    document.querySelectorAll('[data-ctr-lp-sync-price]').forEach((el) => {
      if (el.closest('[data-ctr-lp-sync-pricing]')) return;
      // Sections with "Always use fallback pricing" opt out of live sync.
      if (el.closest('[data-ctr-lp-pricing-lock]')) return;
      if (pricing?.price) {
        el.textContent = pricing.price;
      }
    });

    if (!hasLivePricing) return;

    document.querySelectorAll('[data-ctr-lp-sync-cta]').forEach((el) => {
      if (el.closest('[data-ctr-lp-sync-pricing]')) return;
      // Sections with "Always use fallback pricing" opt out of live sync.
      if (el.closest('[data-ctr-lp-pricing-lock]')) return;
      const template = el.dataset.template || '';
      const ctaText = applyPricingTemplate(template, values);
      if (ctaText) {
        el.textContent = ctaText;
      }
    });
  }

  function selectInitialFrequency(sectionEl) {
    if (!sectionEl) return;
    const index = parseInt(sectionEl.dataset.initialFrequency || '0', 10);
    const frequencies = sectionEl.querySelectorAll(
      '.variant-pack-form__frequencies [name="frequency"]'
    );
    if (!frequencies.length) return;
    const target = frequencies[index] || frequencies[0];
    if (target && !target.checked) {
      target.click();
    }
  }

  function preselectFirstVariant(sectionEl) {
    const form = sectionEl?.querySelector('.variant-pack-form');
    if (!form || form.dataset.ctrLpVariantPreselected) return true;

    const formData = window.Alpine?.$data?.(form);
    if (!formData?.addToPack) return false;

    const firstSelector = form.querySelector('.variant-pack-form__selector');
    const firstVariant = firstSelector && window.Alpine.$data(firstSelector)?.variant;
    if (!firstVariant) {
      const toggleBtn = firstSelector?.querySelector('.variant-pack-form__selector-image-wrapper');
      if (toggleBtn && !form.dataset.ctrLpVariantPreselectClicked) {
        form.dataset.ctrLpVariantPreselectClicked = 'true';
        toggleBtn.click();
      }
      return false;
    }

    if (formData.isInPack?.(firstVariant.id)) {
      form.dataset.ctrLpVariantPreselected = 'true';
      return true;
    }

    if (formData.isSingleSelect?.()) {
      formData.toggleSingleSelection?.(firstVariant);
    } else {
      formData.addToPack(firstVariant);
    }

    form.dataset.ctrLpVariantPreselected = 'true';
    return true;
  }

  function initBuyboxVariantPreselect(sectionEl) {
    if (!sectionEl || preselectFirstVariant(sectionEl)) return;

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (preselectFirstVariant(sectionEl) || attempts >= 20) {
        window.clearInterval(timer);
      }
    }, 250);
  }

  function readFrequencyPrice(input) {
    if (!input) return null;
    try {
      const data = window.Alpine?.$data?.(input);
      if (data?.rawPrice != null) {
        const compareCents = data.rawComparePrice || data.rawOriginalPrice;
        return {
          price: formatMoneyFromCents(data.rawPrice),
          compare: compareCents ? formatMoneyFromCents(compareCents) : null,
        };
      }
    } catch (_e) {
      /* Alpine may not be ready */
    }

    const label = input.closest('.variant-pack-form__frequency');
    const priceEl = label?.querySelector('.variant-pack-form__frequency-price');
    const compareEl = label?.querySelector('.compare-at-price, [class*="compare"]');
    const scrapedPrice = priceEl?.textContent?.trim() || null;
    const scrapedCompare = compareEl?.textContent?.trim() || null;

    return {
      price: isValidDisplayPrice(scrapedPrice) ? scrapedPrice : null,
      compare: isValidDisplayPrice(scrapedCompare) ? scrapedCompare : null,
    };
  }

  document.addEventListener('click', onDocumentClick);
  document.addEventListener('click', onHeaderVariantPackClick, true);

  window._mfrAlpineRegistered = window._mfrAlpineRegistered || {};

  function registerCtrLpAlpineData() {
    if (window._mfrAlpineRegistered.ctrLpBuybox) return;

    Alpine.data('ctrLpBuyboxPanel', () => ({
        displayPrice: '',
        displayCompare: '',
        displayPromoBadge: '',
        displaySupplyBadge: '',
        displayPriceNote: '',
        displayPerDay: '',
        displaySubscriptionFooter: '',
        showPromoBadge: false,
        showSubscriptionFooter: false,
        _fallbackPrice: '',
        _fallbackCompare: '',
        _templates: {},

        init() {
          const sectionEl = this.$el.closest('[data-ctr-lp-buybox]');
          const configEl = sectionEl || this.$el;

          try {
            this._templates = JSON.parse(configEl.dataset.ctrLpBuyboxConfig || '{}');
          } catch (_e) {
            this._templates = {};
          }

          const priceEl = this.$el.querySelector('.ctr-lp-product-buybox__price-current');
          const compareEl = this.$el.querySelector('.ctr-lp-product-buybox__price-compare');
          this._fallbackPrice = priceEl?.textContent?.trim() || '';
          this._fallbackCompare = compareEl?.textContent?.trim() || '';
          this.displayPrice = this._fallbackPrice;
          this.displayCompare = this._fallbackCompare;

          const perDayEl = this.$el.querySelector('.ctr-lp-product-buybox__price-note--desktop strong');
          this._fallbackPerDay = perDayEl?.textContent?.trim() || '';
          this.displayPerDay = this._fallbackPerDay;

          const promoEl = this.$el.querySelector('[data-ctr-lp-buybox-promo-badge]');
          const supplyEl = this.$el.querySelector('[data-ctr-lp-buybox-supply-badge]');
          const priceNoteEl = this.$el.querySelector('[data-ctr-lp-buybox-price-note]');
          const footerEl = this.$el.querySelector('[data-ctr-lp-buybox-subscription-footer]');

          if (!this._templates.promoBadge && promoEl) {
            this._templates.promoBadge = promoEl.dataset.template || promoEl.textContent?.trim() || '';
          }
          if (!this._templates.supplyBadge && supplyEl) {
            this._templates.supplyBadge = supplyEl.dataset.template || supplyEl.textContent?.trim() || '';
          }
          if (!this._templates.priceNote && priceNoteEl) {
            this._templates.priceNote = priceNoteEl.dataset.template || priceNoteEl.innerHTML?.trim() || '';
          }
          if (!this._templates.subscriptionFooter && footerEl) {
            this._templates.subscriptionFooter =
              footerEl.dataset.template || footerEl.textContent?.trim() || '';
          }

          if (sectionEl?.dataset.layoutVariant === 'primary_essentials' && this._templates.priceNote) {
            this.displayPriceNote = applyPricingTemplate(this._templates.priceNote, {
              perDay: this._fallbackPerDay.replace(/\/day$/i, '').trim(),
              discount: '40',
              days: '30',
            });
          }

          this.$nextTick(() => {
            selectInitialFrequency(sectionEl);
            initBuyboxVariantPreselect(sectionEl);
            this.syncFromFrequency();
          });

          sectionEl?.addEventListener('change', (event) => {
            if (event.target?.matches?.('[name="frequency"]')) {
              this.syncFromFrequency(event.target);
            }
          });
        },

        syncFromFrequency(input) {
          const sectionEl = this.$el.closest('[data-ctr-lp-buybox]');
          const active =
            input ||
            sectionEl?.querySelector('.variant-pack-form__frequencies [name="frequency"]:checked');
          const pricing = readFrequencyPricing(active);

          if (pricing?.price && isValidDisplayPrice(pricing.price)) {
            this.displayPrice = pricing.price;
          } else {
            this.displayPrice = this._fallbackPrice;
          }

          if (pricing?.compare && isValidDisplayPrice(pricing.compare)) {
            this.displayCompare = pricing.compare;
          } else {
            this.displayCompare = this._fallbackCompare;
          }

          const isPe = sectionEl?.dataset.layoutVariant === 'primary_essentials';
          const display = buildPricingDisplayValues(pricing, this._templates);
          const templateValues = buildTemplateValues(pricing);
          this.displayPromoBadge = display.promoBadge;
          this.displaySupplyBadge = display.supplyBadge ?? this._templates.supplyBadge ?? '';
          this.displayPerDay = templateValues.perDay
            ? `${templateValues.perDay}/day`
            : this._fallbackPerDay;
          this.displaySubscriptionFooter = display.subscriptionFooter;
          this.showPromoBadge = Boolean(display.promoBadge);
          this.showSubscriptionFooter = Boolean(display.subscriptionFooter);

          if (isPe && this._templates.priceNote) {
            this.displayPriceNote = applyPricingTemplate(this._templates.priceNote, {
              perDay: templateValues.perDay || this._fallbackPerDay.replace(/\/day$/i, '').trim(),
              discount: templateValues.discount || '40',
              days: templateValues.days || '30',
            });
          } else {
            this.displayPriceNote = display.priceNote;
          }
          syncGalleryPricing(pricing);
          syncPurchaseCards(pricing);
        },
      }));

      Alpine.data('ctrLpBuybox', (config = {}) => ({
        dynamicBoxId: config.dynamicBoxId || '',
        init() {
          this.$el.classList.add('is-initialized');
        },
        scrollToBuybox() {
          scrollToBuybox();
        },
      }));

    window._mfrAlpineRegistered.ctrLpBuybox = true;
  }

  document.addEventListener('alpine:init', registerCtrLpAlpineData);

  if (window.Alpine?.data) {
    registerCtrLpAlpineData();
  }

  const BUYBOX_RATING_SELECTOR = '[data-ctr-lp-buybox-rating]';
  const BUYBOX_RATING_OUT_OF_CLASS = 'ctr-lp-product-buybox__rating-out-of';

  function parseRatingFromLabel(label) {
    if (!label) return null;
    const match =
      label.match(/(\d+(?:\.\d+)?)\s*(?:out of|\/)\s*5/i) ||
      label.match(/rated\s*(\d+(?:\.\d+)?)/i);
    return match ? match[1] : null;
  }

  function ensureBuyboxRating(container) {
    if (!container || container.dataset.ctrLpRatingReady) return true;

    if (container.classList.contains('ctr-lp-product-buybox__rating--static')) {
      container.dataset.ctrLpRatingReady = 'true';
      container.classList.add('is-rating-ready');
      return true;
    }

    const okeSr = container.querySelector('.oke-sr');
    if (!okeSr || !okeSr.querySelector('.oke-sr-stars')) return false;

    const anchor = okeSr.querySelector('.oke-is-clickable') || okeSr;
    let ratingEl = okeSr.querySelector('.oke-sr-rating');
    const ratingValue =
      ratingEl?.textContent?.trim() ||
      container.dataset.ratingFallback ||
      parseRatingFromLabel(anchor.getAttribute('aria-label')) ||
      parseRatingFromLabel(okeSr.getAttribute('aria-label'));

    if (ratingValue) {
      if (!ratingEl) {
        ratingEl = document.createElement('span');
        ratingEl.className = 'oke-sr-rating';
        const stars = okeSr.querySelector('.oke-sr-stars');
        if (stars) {
          anchor.insertBefore(ratingEl, stars);
        } else {
          anchor.prepend(ratingEl);
        }
      }
      ratingEl.textContent = ratingValue;
    }

    const isPe = container.closest('[data-layout-variant="primary_essentials"]');

    if (!isPe) {
      if (ratingEl) {
        ratingEl.hidden = false;
        ratingEl.removeAttribute('aria-hidden');
        ratingEl.style.removeProperty('display');
      }

      if (!okeSr.querySelector(`.${BUYBOX_RATING_OUT_OF_CLASS}`)) {
        const outOf = document.createElement('span');
        outOf.className = BUYBOX_RATING_OUT_OF_CLASS;
        outOf.setAttribute('aria-hidden', 'true');
        outOf.textContent = 'out of 5';

        if (ratingEl) {
          ratingEl.insertAdjacentElement('afterend', outOf);
        } else {
          const stars = okeSr.querySelector('.oke-sr-stars');
          if (stars) {
            stars.before(outOf);
          } else {
            anchor.appendChild(outOf);
          }
        }
      }
    } else {
      okeSr.querySelector(`.${BUYBOX_RATING_OUT_OF_CLASS}`)?.remove();
    }

    applyBuyboxRatingScrollAnchor(container, okeSr);

    container.dataset.ctrLpRatingReady = 'true';
    container.classList.add('is-rating-ready');
    return true;
  }

  function applyBuyboxRatingScrollAnchor(container, okeSr) {
    const scrollAnchor = container?.dataset?.ctrLpRatingScrollAnchor;
    if (!scrollAnchor || !okeSr) return;

    const clickable = okeSr.querySelector('.oke-is-clickable') || okeSr.querySelector('a');
    if (!clickable) return;

    clickable.setAttribute('href', scrollAnchor);
    clickable.setAttribute('aria-label', 'View customer reviews');
  }

  function watchBuyboxRatings(root = document) {
    root.querySelectorAll(BUYBOX_RATING_SELECTOR).forEach((container) => {
      if (ensureBuyboxRating(container)) return;

      const observer = new MutationObserver(() => {
        if (ensureBuyboxRating(container)) {
          observer.disconnect();
        }
      });
      observer.observe(container, { childList: true, subtree: true, characterData: true });
    });
  }

  function initBuyboxRatings() {
    watchBuyboxRatings();
    window.setTimeout(() => watchBuyboxRatings(), 1500);
    window.setTimeout(() => watchBuyboxRatings(), 4000);
  }

  function initBuyboxGalleryFooterA11y() {
    syncGalleryFooterA11y();
    window.addEventListener('resize', syncGalleryFooterA11y);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBuyboxRatings);
    document.addEventListener('DOMContentLoaded', initBuyboxGalleryFooterA11y);
  } else {
    initBuyboxRatings();
    initBuyboxGalleryFooterA11y();
  }

  function onBuyboxRatingReady() {
    initBuyboxRatings();
  }

  document.addEventListener('okeWidgetInitialised', onBuyboxRatingReady);
  document.addEventListener('oke-reviews-widget-loaded', onBuyboxRatingReady);

  window.ctrLpBuybox = {
    scrollToBuybox,
    triggerBuyboxAtc,
    getBuyboxElement,
    selectInitialFrequency,
    preselectFirstVariant,
    initBuyboxVariantPreselect,
    ensureBuyboxRating,
    watchBuyboxRatings,
    syncPurchaseCards,
    syncGalleryPricing,
    syncGalleryFooterA11y,
    readFrequencyPricing,
    getPerDayBasis,
  };
})();
